import * as React from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
	Table,
	TableBody,
	TableCaption,
	TableCell,
	TableFooter,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { PencilLine, ArrowLeft } from "lucide-react";
import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
} from "@/components/ui/card";

import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

const DataTest = [
	{
		id: 1,
		title: "ໜີ້ສິນໝູນວຽນ",
		Sumtitles: "ລວມຍອດ ໜີ້ສິນໝູນວຽນ ( I )",
		sumthisyear: "257.789,80",
		sumlastyear: "29.000,00",
		Details: [
			{
				subtitle: "ເງິນເບີກເກີນບັນຊີ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: "ໜີ້ຕ້ອງສົ່ງການຄ້າ ແລະ ອື່ນໆ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "9",
			},
			{
				subtitle: "ໜີ້ສິນການເງິນ, ເງິນກູ້ຢືມ ໄລຍະສັ້ນ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: "ໜີ້ຕ້ອງສົ່ງລັດ (ຄ່າພາສີ-ອາກອນ)",
				thisyear: "42.339,80",
				lastyear: "1.500,00",
				Note: "10",
			},
			{
				subtitle: "ພັນທະໄລຍະສັ້ນ ຜົນປະໂຫຍດຂອງພະນັກງານ",
				thisyear: "23.100,00",
				lastyear: "10.500,00",
				Note: "11",
			},
			{
				subtitle: " ໜີ້ຕ້ອງສົ່ງ ໝູນວຽນອື່ນໆ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: " ເງິນແຮ-ໜີ້ສິນໝູນວຽນ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
		],
	},
	{
		id: 2,
		title: "ໜີ້ສິນບໍ່ໝູນວຽນ",
		Sumtitles: "ລວມຍອດ ໜີ້ສິນໝູນວຽນ ( I )",
		sumthisyear: "257.789,80",
		sumlastyear: "29.000,00",
		Details: [
			{
				subtitle: "ເງິນເບີກເກີນບັນຊີ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: "ໜີ້ຕ້ອງສົ່ງການຄ້າ ແລະ ອື່ນໆ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "9",
			},
			{
				subtitle: "ໜີ້ສິນການເງິນ, ເງິນກູ້ຢືມ ໄລຍະສັ້ນ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: "ໜີ້ຕ້ອງສົ່ງລັດ (ຄ່າພາສີ-ອາກອນ)",
				thisyear: "42.339,80",
				lastyear: "1.500,00",
				Note: "10",
			},
			{
				subtitle: "ພັນທະໄລຍະສັ້ນ ຜົນປະໂຫຍດຂອງພະນັກງານ",
				thisyear: "23.100,00",
				lastyear: "10.500,00",
				Note: "11",
			},
			{
				subtitle: " ໜີ້ຕ້ອງສົ່ງ ໝູນວຽນອື່ນໆ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: " ເງິນແຮ-ໜີ້ສິນໝູນວຽນ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
		],
	},
	{
		id: 3,
		title: "ທຶນຕົນເອງ",
		Sumtitles: "ລວມຍອດ ໜີ້ສິນໝູນວຽນ ( I )",
		sumthisyear: "257.789,80",
		sumlastyear: "29.000,00",
		Details: [
			{
				subtitle: "ເງິນເບີກເກີນບັນຊີ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: "ໜີ້ຕ້ອງສົ່ງການຄ້າ ແລະ ອື່ນໆ",
				thisyear: "192.350,00",
				lastyear: "17.000,00",
				Note: "9",
			},
			{
				subtitle: "ໜີ້ສິນການເງິນ, ເງິນກູ້ຢືມ ໄລຍະສັ້ນ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: "ໜີ້ຕ້ອງສົ່ງລັດ (ຄ່າພາສີ-ອາກອນ)",
				thisyear: "42.339,80",
				lastyear: "1.500,00",
				Note: "10",
			},
			{
				subtitle: "ພັນທະໄລຍະສັ້ນ ຜົນປະໂຫຍດຂອງພະນັກງານ",
				thisyear: "23.100,00",
				lastyear: "10.500,00",
				Note: "11",
			},
			{
				subtitle: " ໜີ້ຕ້ອງສົ່ງ ໝູນວຽນອື່ນໆ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
			{
				subtitle: " ເງິນແຮ-ໜີ້ສິນໝູນວຽນ",
				thisyear: "",
				lastyear: "",
				Note: "",
			},
		],
	},
];
export const Route = createFileRoute(
	"/_layout-private/report/finance/bank/_layout/finance-debt/",
)({
	component: finaceDebt,
});

function finaceDebt() {
	const navigate = useNavigate();

	return (
		<section>
			<Card className="border-none">
				<CardHeader className="border-b mb-[32px]">
					<button
						type="button"
						onClick={() =>
							navigate({
								to: "/report/finance",

							})
						}
						className="flex items-center gap-[4px]  mb-4"
					>
						<ArrowLeft className="w-5 h-5" />
						ກັບຄືນ
					</button>

					<CardTitle>ລາຍລະອຽດເອກະສານທາງການເງິນງວດປີ 2023</CardTitle>
					<CardDescription>ລາຍລະອຽດ</CardDescription>

					<div className="flex justify-end w-full mt-5 mb-5 gap-x-2">
						<Button
							type="button"
							onClick={() =>
								navigate({
									to: "/report/finance/bank/finance-debt/edit",

								})
							}
							variant="secondary"
							className="flex items-center border border-blue-500 bg-none gap-x-1 w-[120px] rounded-md  p-2 text-blue-500"
						>
							<PencilLine /> ແກ້ໄຂ
						</Button>
					</div>
				</CardHeader>
				<CardContent>
					<div className="flex items-center gap-x-1">
						<Label htmlFor="">ຫົວໜ່ວຍເງິນ</Label>
						<Select onValueChange={(value) => console.log(value)}>
							<SelectTrigger className="w-[150px] indent-1 border-none underline text-blue-500 font-bold	">
								<SelectValue placeholder="ເລືອກການສະແດງ" />
							</SelectTrigger>
							<SelectContent>
								<SelectItem value="kip">ກີບ</SelectItem>
								<SelectItem value="baht">ບາດ</SelectItem>
							</SelectContent>
						</Select>
					</div>

					<div>
						<Table className="mb-4 ">
							<TableHeader>
								<TableRow>
									<TableHead className="w-auto border">ໜີ້ສິນ ແລະ ທຶນ</TableHead>
									<TableHead className="w-auto border">
										ມູນຄ່າຍັງເຫຼືອ(ປີນີ້)2023
									</TableHead>
									<TableHead className="w-auto border">
										ມູນຄ່າຍັງເຫຼືອ(ປີຜ່ານມາ) 2022
									</TableHead>
									<TableHead className="w-auto border">ໝາຍເຫດ</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								{DataTest.map((invoice, index) => (
									<>
										<TableRow
											key={index}
											className="font-bold cursor-pointer bg-gray-100"
										>
											<TableCell className="border">
												{invoice.id} {invoice.title}
											</TableCell>
											<TableCell className="border">{""}</TableCell>
											<TableCell className="border">{""}</TableCell>
											<TableCell className="border">{""}</TableCell>
										</TableRow>
										{invoice.Details.map((invoices, index) => (
											<TableRow key={index} className="cursor-pointer">
												<TableCell className="border">
													{invoice.id}.{index} {invoices.subtitle}
												</TableCell>
												<TableCell className="border">
													{invoices.thisyear}
												</TableCell>
												<TableCell className="border">
													{invoices.lastyear}
												</TableCell>
												<TableCell className="border">
													{invoices.Note}
												</TableCell>
											</TableRow>
										))}
										<TableRow key={index} className="bg-gray-100">
											<TableCell className="border">
												{invoice.id}.{index} {invoice.Sumtitles}
											</TableCell>
											<TableCell className="border">
												{invoice.sumthisyear}
											</TableCell>
											<TableCell className="border">
												{invoice.sumlastyear}
											</TableCell>
											<TableCell className="border">{"-"}</TableCell>
										</TableRow>
										<TableRow key={index}>
											<TableCell className="h-25" colSpan={4}>
												{" "}
											</TableCell>
										</TableRow>
									</>
								))}
							</TableBody>
						</Table>
					</div>

					<div className="flex items-center justify-between w-full mt-12">
						<p>ທັງໝົດ 56 ລາຍການ </p>
						<div className="flex items-center space-x-2">
							<p>ໜ້າ 1 of 10</p>
							<div className="flex space-x-2">
								<button type="button" className="p-2 border rounded-md">
									&lt;&lt;
								</button>
								<button type="button" className="p-2 border rounded-md">
									&lt;
								</button>
								<button type="button" className="p-2 border rounded-md">
									&gt;
								</button>
								<button type="button" className="p-2 border rounded-md">
									&gt;&gt;
								</button>
							</div>
						</div>
					</div>
				</CardContent>
			</Card>
		</section>
	);
}
